<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-3">
    <div class="row mt-0" v-if="displayOrganisationid == -1">
      <div class="col-12 custom-form-main-label">{{$t('add_organisation')}}</div>
    </div>
    <div class="row mt-0" v-if="displayOrganisationid != -1">
      <div class="col-12 custom-form-main-label">{{$t('manage_organisation')}}</div>
    </div>
    <div class="row">
      <div class="col-12">
        <form id="createOrganisationForm" name="createOrganisationForm" class="login-formx form-validate" action="index.html" onsubmit="return false">
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('organisation_name')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input required v-model="orgname" type="text" id="txtorgname" v-bind:placeholder="$t('organisation_name')" maxlength="200" name="orgname" class="form-control" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('email')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input v-model="email" type="email" id="txtemail" v-bind:placeholder="$t('email')" maxlength="200" name="email" class="form-control" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('phone')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input v-model="phone" type="text" id="txtphone" v-bind:placeholder="$t('phone')" maxlength="200" name="phone" class="form-control" />
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-12">
              <button @click="createOrganisation" type="submit" class="btn skin primary-button pull-right"><i class="icon-cog5 mr-2"></i> {{$t('save')}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
   
  </div>
</template>

<script>
  let message = "";
  var displayOrganisationid = -1;
  export default {
    name: "add-Organisation",
    components: {

    },
    props: {
      organisationid: {
        type: Number,
        default: -1
      },
    },
    data() {
      return {
        message: "",
        orgname: "",        
        email: "",
        phone: "",
        displayOrganisationid : this.organisationid
      };
    },
    methods: {
      clearFields() {
        this.orgname = '';
        this.email = '';
        this.phone = '';
      },
      async createOrganisation() {
        if (!$('#createOrganisationForm').valid())
          return false;
        var request = { Organisationid: this.organisationid, Organization: this.orgname, Email: this.email, Telephone: this.phone };

        try {
          var response = await this.$http.post(
            '/api/Organizations/v1',
            request
          ).then(async response => {
            this.clearFields();
            vm.$root.$emit('refreshview');
          });

        } catch (err) {
          alert(err);
        }
      },
      async getOrganisation(OrganisationtId) {
        try {          
          this.$http.get(`/api/Organizations/v1/${OrganisationtId}`).then(async response => {
            var contact = response.data;
            this.orgname = contact.Organization;            
            this.email = contact.Email;
            this.phone = contact.Telephone;            
          });
        } catch (err) {
          alert('some error:' + err)
        }
      }
    },
    watch: {
      organisationid: function (newVal, oldVal) {
        if (newVal > 0) {
          this.displayOrganisationid = newVal;
          this.getOrganisation(newVal);
        } else {
          this.orgname = '';
          this.email = '';
        }
      }
    },
    mounted() {
      _componentValidation('#createOrganisationForm');
      if (this.organisationid > 0) {
        this.getOrganisation(this.organisationid);
      }
    }
  };
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/organisation/add-organisation.vue